<template>
  <v-container>
    <div class="d-flex justify-space-between">
      <h2 color="#6A158E" class="page-heading" v-text="page_title"></h2>
      <!-- {{ permitObj }} -->
      <bread-crumbs :items="breadItems"></bread-crumbs>
    </div>
    <v-card :loading="loading">
      <v-form>
        <v-container>
          <fieldset>
            <legend>Mark Attendance</legend>
            <v-row class="ml-minus-18">
              <v-col cols="12" sm="4" md="4">
                <v-date-picker :first-day-of-week="1" elevation="15" v-model="picker2" color="green lighten-1"
                  header-color="primary" :max="new Date().toISOString().substr(0, 10)"></v-date-picker>
              </v-col>
              <v-col cols="12" sm="8" md="8">
                <v-row>
                  <v-col>
                    <label class="custom-label">Select Group Session</label>
                    <v-autocomplete :error-messages="errors.group_session_id" v-model="data.group_session_id"
                      :items="groups" solo label="Group Session" placeholder="Group Session"
                      item-text="group_session_id" item-value="group_session_id" @select="students = []">
                      <template slot="item" slot-scope="data">
                        {{ data.item.group_session_id }} -
                        {{ data.item.group.tutor.tutor_fname }}
                        {{ data.item.group.tutor.tutor_lname }}
                      </template>
                      <template slot="selection" slot-scope="data">
                        {{ data.item.group_session_id }} -
                        {{ data.item.group.tutor.tutor_fname }}
                        {{ data.item.group.tutor.tutor_lname }}
                      </template>
                    </v-autocomplete>
                  </v-col>
                </v-row>

                <v-row>
                  <v-col>
                    <v-btn @click="getStudents" :loading="loading" color="#6A158E" dark>Submit</v-btn>
                  </v-col>
                </v-row>
              </v-col>
            </v-row>

            <v-row>
              <v-col>
                <table style="border: 1px solid lightgrey; width: 100%">
                  <tr style="text-align: left">
                    <th>Name</th>
                    <th>Hours</th>
                    <th style="width: 120px">Hours Attended</th>
                    <th style="">Catchup</th>
                    <th>Notes</th>
                  </tr>
                  <tr v-for="(student, index) in students" v-bind:key="student.std_id">
                    <td>{{ student.std_fname }} {{ student.std_lname }}</td>
                    <td>
                      <v-text-field v-model="student.week_hours[Object.keys(student.week_hours)[1]]" solo readonly>
                      </v-text-field>
                    </td>
                    <td>
                      <v-text-field placeholder="Hours" solo v-model="data[index].hours"></v-text-field>
                    </td>
                    <td style="">
                      <p>
                        <v-checkbox class="mx-2" v-model="data[index].catchup"></v-checkbox>
                      </p>
                    </td>
                    <td>
                      <v-textarea height="20px" placeholder="Notes" solo v-model="data[index].notes"></v-textarea>
                    </td>
                  </tr>
                </table>
              </v-col>
            </v-row>
          </fieldset>

          <v-row>
            <v-col cols="12" v-if="showSaveButton">
              <v-btn @click="save" :loading="loading" color="#6A158E" dark>Save</v-btn>
            </v-col>
            <v-col cols="12" v-else>
              <v-btn @click="save" :loading="loading" color="#6A158E" dark>Update</v-btn>
            </v-col>
          </v-row>
        </v-container>
      </v-form>
    </v-card>
    <v-overlay :value="overlay">
      <v-progress-circular indeterminate size="64"></v-progress-circular>
    </v-overlay>
  </v-container>
</template>

<script>
import Form from "../../../utils/form";
import BreadCrumbs from "../../../components/BreadCrumbs";
import { getPermitObjects } from "../../../utils/allowedPermissions";

export default {
  name: "WorkForm",
  components: { BreadCrumbs },
  props: {
    id: {
      type: Number,
      default: null,
    },
  },
  data() {
    return {
      permitObj: {},
      showSaveButton: true,
      overlay: false,
      page_title: this.$route.meta.title,

      breadItems: [
        {
          text: "Dashboard",
          disabled: false,
          href: "/",
          to: {
            name: "DashBoard",
          },
        },
        {
          text: this.$route.meta.title,
          disabled: true,
          to: {
            name: this.$route.name,
          },
        },
      ],
      work_types: ["home", "class"],
      loading: false,
      type: [
        { value: "classes", text: "Class Work" },
        { value: "home", text: "Home Work" },
      ],
      filters: {},
      picker2: new Date().toISOString().substr(0, 10),

      data: {},
      students: [],
      errors: {},
      tutor_search: "",
      tutors: [],
      groups: [],
      group_search: "",
    };
  },
  computed: {
    filteredStudents: function () {
      return this.students.filter((stud) => {
        if (typeof Object.keys(stud.week_hours)[1] !== "undefined") {
          let h = stud.week_hours[Object.keys(stud.week_hours)[1]];
          if (h > 0) return stud;
        }
      });
    },
  },
  watch: {
    picker2: function (val) {
      // watch it
      //   alert(val)
      this.getSessions();
    },
  },

  methods: {
    getSessions() {
      axios
        .get("group/sessions", {
          params: {
            date: this.picker2,
          },
        })
        .then((response) => {
          // console.log(response)
          // this.students = response.data.response
          this.groups = response.data.groups;
          // this.data.push(this.stud)
          // response.data.response.map((student,index) => {
          //     var array = {
          //         'id' : student.std_id,
          //         'hours' : '',
          //     }
          //     this.data[index] = array

          // })
        });
    },
    getPermittedArray() {
      console.log(this.$store, 'this.$store from Attendance');
      let links = this.$store?.getters?.permissions;
      let pathName = "Attendance";
      this.permitObj = getPermitObjects(links, pathName)
    },
    getStudents() {
      if (typeof this.data.group_session_id == "undefined") {
        Toast.fire({
          icon: "error",
          text: "Please select a group session!",
        });
        return;
      }
      this.overlay = true;
      var filters = {
        picker2: this.picker2,
        session_id: this.data.group_session_id,
      };
      // this.students = [];
      axios
        .post("attendance/students", filters)
        .then((response) => {
          this.overlay = false;

          // console.log(response)
          if (response.data.response.length == 0) {
            Toast.fire({
              icon: "error",
              title: "No Students in this group session!",
            });
          }
          // this.groups = response.data.groups
          // this.data.push(this.stud)
          this.showSaveButton = true;
          response.data.response.forEach((student, index) => {
            if (student.week_hours == null) {
              Toast.fire({
                icon: "error",
                title: "Week hours not defined for one of the students in this group session!",
              });
              return false;
            }
            if (typeof Object.keys(student.week_hours)[1] !== "undefined") {
              var array = {
                id: student.std_id,
                hours: "",
                total_hours: student.week_hours[Object.keys(student.week_hours)[1]],
                group_session_attendance_id: "",
              };
              this.data[index] = array;
            }
            if (
              student.group_session_attendance != null &&
              student.group_session_attendance.length > 0
            ) {
              let group_session_attendance =
                student.group_session_attendance[
                student.group_session_attendance.length - 1
                ];
              this.data[index].hours =
                group_session_attendance.hours != null
                  ? group_session_attendance.hours
                  : 0;
              this.data[index].notes =
                group_session_attendance.hours != ""
                  ? group_session_attendance.notes
                  : "";
              this.data[index].group_session_attendance_id =
                group_session_attendance.group_session_attendance_id;
              if (group_session_attendance.attendance_status == "catchup") {
                this.data[index].catchup = true;
              } else {
                this.data[index].catchup = false;
              }
              this.showSaveButton = false;
            }
          });
          this.students = response.data.response;
        })
        .catch((error) => {
          this.overlay = false;
        });
    },
    create() {
      if (this.students.length == 0) {
        Toast.fire({
          icon: "error",
          title: "No students in the session!",
        });
        return;
      }
      this.loading = true;
      // let form = new Form({...this.data})
      var data = {
        group_session_id: this.data.group_session_id,
        data: this.data,
      };
      axios
        .post("save/attendance", data)
        .then((response) => {
          Toast.fire({
            icon: "success",
            title: "Attendance Saved",
          });
          // this.$router.replace({name: "CatchUps"})
          // this.loading = false
          this.loading = false;
          this.students = [];
          this.$refs.form.reset();
          this.getSessions();
        })
        .catch((response) => {
          if (response.status === 400) {
            this.errors = response.data;
          }
          // alert(response.status)
          if (response.status === 422) {
            //    console.log(response.data)
            this.errors = response.data.errors;
          }
          this.loading = false;
        });
    },
    save() {
      this.create();
    },
  },
  mounted() {
    this.getPermittedArray();
    this.getSessions();
  },
};
</script>

<style lang="scss" scoped>
fieldset {
  border: 0;

  &:not(:last-of-type) {
    border-bottom: 1px dashed #8898aa80;
    margin-bottom: 20px;
  }

  & legend {
    font: Bold 20px/25px Lato;
    color: #172b4d;
  }
}

.page-heading {
  font: 300 22px/26px;
  font-family: "Gotham Narrow";
  color: #6a158e;
}
</style>
